var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M4.34 9.55v-.41a7.64 7.64 0 0 1 15.3 0v.41m-15.3 0h-.17A3.2 3.2 0 0 0 1 12.8a3.2 3.2 0 0 0 3.17 3.24h.2c.4 3.48 3.68 6.47 7.62 6.47 3.93 0 7.22-2.99 7.6-6.47h.24A3.2 3.2 0 0 0 23 12.8a3.2 3.2 0 0 0-3.17-3.24h-.2m-15.3 0v6.48m15.3-6.48v6.48m-4.3 1.47a3.59 3.59 0 0 1-3.47 2.36c-.97 0-1.86-.36-2.52-.95m1.76-5.28c-.49.66-.15 1.92.76 2.14m4.65-8.3c-.76-1.03-2.42-.98-3.26-.22M7.7 6.32c.76-.83 2.41-.79 3.26-.18m-.35 4.4c0-2.06-2.58-2.06-2.58 0 0 1.98 2.58 1.98 2.58 0Zm5.24 0c0-2.06-2.58-2.06-2.58 0 0 2 2.58 2 2.58 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users2.faf15d5c85010e57674b11fe44c53041.svg";
export { ForwardRef as ReactComponent };